export default __webpack_public_path__ + "static/media/gallery-wip-denix-scope-mount-hole_00.486480e4.jpg";